import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { MentionProcessorService } from "@shared/services/mention-processor.service";

@Pipe({
  name: "fixLegacyUserUrls",
  pure: true
})
export class FixLegacyUserUrlsPipe implements PipeTransform {
  constructor(
    private readonly _mentionProcessorService: MentionProcessorService,
    private readonly _domSanitizer: DomSanitizer
  ) {}

  transform(html: string): string;
  transform(html: SafeHtml): SafeHtml;
  transform(html: null | undefined): null | undefined;
  transform(html: string | SafeHtml | null | undefined): string | SafeHtml | null | undefined {
    if (!html) {
      return html;
    }

    // If it's a SafeHtml, we need to extract the string, process it, and re-sanitize
    if (this._isSafeHtml(html)) {
      const htmlString = this._extractHtmlString(html);
      const processed = this._mentionProcessorService.fixLegacyUserUrls(htmlString);
      return this._domSanitizer.bypassSecurityTrustHtml(processed);
    }

    // Regular string processing
    return this._mentionProcessorService.fixLegacyUserUrls(html);
  }

  private _isSafeHtml(value: string | SafeHtml): value is SafeHtml {
    return typeof value === "object" && value !== null;
  }

  private _extractHtmlString(safeHtml: SafeHtml): string {
    // Angular's SafeHtml wraps the HTML string in an object
    // We can access it via the internal structure or use toString
    // The safest way is to convert to string which Angular handles internally
    return String(safeHtml);
  }
}
